/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useFormContext } from "./use-form-context";

export function useFormState () {
    const context = useFormContext();
    return context.state;
}
